import React, { Component } from 'react'
import Form from 'devextreme-react/form'

class FormPengalihan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formData: {},
    }

    this.formRef = React.createRef()

    this.formItems = [
      {
        itemType: 'group',
        name: 'group1',
        colCount: 2,
        items: [
          {
            itemType: 'group',
            cssClass: 'group-form-group',
            caption: 'Saldo Peserta',
            items: [
              {
                dataField: 'totalSaldoMpl',
                label: {
                  text: 'Jumlah Saldo + Manfaat Lain',
                  alignment: 'left',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  format: '#,##0.00',
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Jumlah Saldo + Manfaat Lain',
                },
              },
              {
                dataField: 'klaimTax',
                label: {
                  text: 'Pajak',
                  alignment: 'left',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  format: '#,##0.00',
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Pajak',
                },
              },
              {
                dataField: 'klaimBiayaKomisi',
                label: {
                  text: 'Biaya/Komisi Penutupan Rekening',
                  alignment: 'left',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  format: '#,##0.00',
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Biaya/Komisi Penutupan Rekening',
                },
              },
              {
                dataField: 'klaimAmountNett',
                label: {
                  text: 'Nominal Bersih Pengalihan (Rp)',
                  alignment: 'left',
                },
                editorType: 'dxNumberBox',
                editorOptions: {
                  format: '#,##0.00',
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                    style: 'margin-bottom: 9.5vh !important',
                  },
                  placeholder: 'Nominal Bersih Pengalihan (Rp)',
                },
              },
            ],
          },
          {
            itemType: 'group',
            cssClass: 'group-form',
            caption: 'DPLK Tujuan',
            items: [
              {
                dataField: 'dplkLainPerusahaan',
                label: {
                  text: 'Nama Perusahaan DPLK',
                  alignment: 'left',
                },
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Nama Perusahaan DPLK',
                },
              },
              {
                dataField: 'dplkLainProduct',
                label: {
                  text: 'Nama Produk DPLK',
                  alignment: 'left',
                },
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Nama Produk DPLK',
                },
              },
              {
                dataField: 'dplkLainRekNo',
                label: {
                  text: 'No Rekening DPLK',
                  alignment: 'left',
                },
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'No Rekening DPLK',
                },
              },
              {
                dataField: 'dplkLainRekNama',
                label: {
                  text: 'Nama Rekening DPLK',
                  alignment: 'left',
                },
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Nama Rekening DPLK',
                },
              },
              {
                dataField: 'dplkLainRekBankName',
                label: {
                  text: 'Bank DPLK',
                  alignment: 'left',
                },
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Bank DPLK',
                },
              },
              {
                dataField: 'dplkLainRekCabang',
                label: {
                  text: 'Cabang Bank DPLK',
                  alignment: 'left',
                },
                editorOptions: {
                  elementAttr: {
                    class: 'bd-input-popup-disabled-dapen-default',
                  },
                  placeholder: 'Cabang Bank DPLK',
                },
              },
            ],
          },
        ],
      },
    ]
  }

  loadData = async (data) => {
    this.formRef.current.instance.updateData(data)
  }

  clearData = () => {
    this.setState({ formData: {} })
  }

  sendData = () => {
    return this.state.formData
  }

  render() {
    return (
      <React.Fragment>
        <Form
          id={'penarikan'}
          ref={this.formRef}
          colCount={1}
          formData={this.state.formData}
          items={this.formItems}
          labelLocation="left"
          readOnly={true}
          // scrollingEnabled={true}
        />
      </React.Fragment>
    )
  }
}

export default FormPengalihan
